import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import './styles/global.css';
import { initAppHeight } from '@/lib/appHeight';
import { routerBasename, withBase } from '@/lib/basePath';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element missing');

initAppHeight();

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter basename={routerBasename()}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    const swUrl = withBase('sw.js');
    const scope = routerBasename() ? `${routerBasename()}/` : import.meta.env.BASE_URL;
    navigator.serviceWorker
      .register(swUrl, { scope })
      .then((reg) => {
        if (reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            if (nw.state === 'installed' && navigator.serviceWorker.controller) {
              nw.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => {
        /* offline support is optional */
      });

    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'RELOAD_ONCE') {
        if (sessionStorage.getItem('carvoeiro-nav-sw-reloaded') === '1') return;
        sessionStorage.setItem('carvoeiro-nav-sw-reloaded', '1');
        window.location.reload();
      }
    });
  });
}
